<template>
  <div class="fixed bottom-0 right-0 mr-4 mb-4 md:mr-12 md:mb-12 text-sm">
    <div @click="open = !open" :style="style" :class="{ open: open }" class="share-button md:h-button cursor-pointer border border-current transition-bg flex h-full justify-center items-center px-3 py-1">
      <span v-if="!open" class="uppercase">{{ $t('general', 'share') }}</span>
      <span v-else class="uppercase">{{ $t('general', 'close') }}</span>
    </div>
    <transition name="fade">
      <div v-if="open" :style="style" class="slideout absolute top-0 flex items-center border border-current border-r-0 w-48">
        <img v-if="qr" :src="qr" class="h-full mr-2" />
        <div class="px-3 pr-5 flex-1 cursor-pointer text-center" @click="doCopy">
          <div v-if="!copied">{{ $t('general', 'copyURL') }}</div>
          <div v-else>{{ $t('general', 'copied') }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {

  name: 'Share',

  data () {
    return {
      qr: null,
      open: false,
      copied: false
    }
  },

  computed: {
    style () {
      return this.$store.state.style
    },
    color () {
      var styleColor = this.$store.state.style.color
      if (styleColor.includes('#')) {
        return styleColor
      } else if (styleColor.includes('rgb')) {
        var a = styleColor.split('(')[1].split(')')[0]
        a = a.split(',')
        var b = a.map(function (x) {
          x = parseInt(x).toString(16)
          return (x.length === 1) ? '0' + x : x
        })
        b = '#' + b.join('')
        return b
      } else {
        return '#000'
      }
    }
  },

  methods: {
    doCopy: function () {
      const x = this

      this.$copyText(document.location.href).then(function (e) {
        x.copied = true
        window.setTimeout(() => {
          x.copied = false
        }, 3000)
      }, function (e) {
        alert('Can not copy')
      })
    },
    setQR () {
      QRCode.toDataURL(document.location.href, {
        color: {
          dark: this.color,
          light: '#0000'
        }
      }).then(url => {
        this.qr = url
      }).catch(err => {
        console.log(err)
        this.qr = null
      })
    }
  },

  watch: {
    color () {
      this.$nextTick(() => {
        this.setQR()
      })
    },
    $route () {
      this.$nextTick(() => {
        this.setQR()
      })
    }
  },

  mounted () {
    this.setQR()
  }
}
</script>

<style lang="stylus" scoped>
  .share-button
    width: 80px
    &.open
      height: 80px
  img
    mix-blend-mode: multiply
  .slideout
    height: 80px
    right: 100%
  @media screen and (max-height: 630px)
    .share-button
      display: none

  @media screen and (max-height: 780px)
    .share-button
      background: red
      height: 40px
</style>
